const ShotOutcomeTypes = ["post", "bar", "save", "off_target"];

export const PenaltyShotFailureReason = {
  name: "penalty-shot-failure",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "shot.outcome-type",
  showOn: [{ state: "primary", value: "penalty-shot-failure", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: { value: "useHistory" },
  children: [
    {
      name: "shot-outcome-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "failureReason",
        children: ShotOutcomeTypes,
        layout: "type-button",
      },
      actionGroups: [
        {
          actions: [
            {
              action: "setPossession",
              value: { currentEntity: false },
              type: "main",
            },
          ],
          conditions: [
            {
              item: "optionValue",
              event: "main",
              operator: "is",
              name: "failureReason",
              value: "OFF_TARGET",
            },
          ],
        },
        {
          actions: [
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "clearAllEvents" },
            { action: "nextState", value: null, type: "primary" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
